export const userManagementConstants = Object.freeze({
  userStatus: {
    ACTIVE: 'Active',
    DEACTIVATED: 'Deactivated',
    INVITED: 'Invited',
  },
})
